import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const logzIo = defineConnector({
  identifier: "logzIo",
  name: "Logz.io",
  tagLine: "Cloud observability platform",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api.logz.io/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "X-API-TOKEN",
        value: app.secret.apiToken,
      },
    ]),
  steps: [
    {
      title: "Create a token in Logz.io",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://api-docs.logz.io/docs/logz/logz-io-api](https://api-docs.logz.io/docs/logz/logz-io-api) to create a token for the Logz.io API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.logz.io/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.logz.io/v1/account")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
